function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useEffect, useState } from 'react';
import '@fontsource/fira-mono/400.css';
import '@fontsource/fira-mono/500.css';
import '@fontsource/fira-mono/700.css';
import '@fontsource/fira-sans/300.css';
import '@fontsource/fira-sans/300-italic.css';
import '@fontsource/fira-sans/400.css';
import '@fontsource/fira-sans/400-italic.css';
import '@fontsource/fira-sans/500.css';
import '@fontsource/fira-sans/600.css';
import '@fontsource/fira-sans/700.css';
import '@fontsource/fira-sans/700-italic.css';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var FontsLoadedContext = /*#__PURE__*/createContext(false);
FontsLoadedContext.displayName = 'FontsLoadedContext';
/**
 * FontBootstrap component. Handles preloading fonts.
 */
export function FontBootstrap(_ref) {
  var _ref$fontClassNames = _ref.fontClassNames,
    fontClassNames = _ref$fontClassNames === void 0 ? ['fira-sans-regular', 'fira-sans-semibold', 'fira-mono'] : _ref$fontClassNames,
    children = _ref.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  useEffect(function initFonts() {
    document.fonts.ready.then(() => {
      setIsLoaded(true);
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FontsLoadedContext.Provider, {
      value: isLoaded,
      children: children
    }), /*#__PURE__*/_jsx("div", {
      id: "preload-fonts",
      style: {
        visibility: 'hidden',
        position: 'absolute',
        top: -10000
      },
      children: fontClassNames.map(className => /*#__PURE__*/_jsx("p", {
        className: className,
        children: "preload"
      }, className))
    })]
  });
}
export default FontBootstrap;
//# sourceMappingURL=FontBootstrap.js.map